<template>
    <div class="af-job-apply-form-guest-user afu-my-8">
        <div class="afu-font-semibold afu-text-xs afu-leading-xs md:afu-text-4xl md:afu-leading-4xl afu-mb-7 md:afu-mb-2 afu-text-black">
            {{ $t('apply.apply_with_email', {email: applyEmail}) }}
        </div>
        <ValidationObserver
            ref="formNewUser"
            tag="form"
            class="afu-grid afu-row-gap-8"
            @submit.prevent="register()"
        >
            <ApplyPersonalInfo ref="personalInfo" />

            <ApplyDocuments ref="applyDocuments" />

            <ScreeningQuestion 
                v-if="showScreeningQuestion"
                :job-uuid="$_job.uuid"
                :on-apply-page=true
                ref="screeningQuestions"
            />

            <C1Alert
                v-if="!!response.message"
                :variant="response.status"
            >
                <span v-html="response.message" />
            </C1Alert>

            <ApplyFormFooter />

            <div class="afu-text-center afu-mt-6">
                <MqLayout mq="sm">
                    <C1Button
                        type="submit"
                        size="lg"
                        class="af-btn-apply-submit af-btn-apply-guest-submit"
                        :is-busy="loader.apply"
                        variant="primary"
                        block
                    >
                        {{ $t('apply.apply_for_job') }}
                    </C1Button>
                </MqLayout>
                <MqLayout mq="tsm+">
                    <C1Button
                        type="submit"
                        size="lg"
                        class="af-btn-apply-submit af-btn-apply-guest-submit afu-w-200"
                        :is-busy="loader.apply"
                        variant="primary"
                    >
                        {{ $t('apply.apply_for_job') }}
                    </C1Button>
                </MqLayout>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import has from 'lodash/has';
    import { mapState, mapGetters } from 'vuex';
    import { ValidationObserver } from 'vee-validate';
    import ApplyPersonalInfo from './ApplyPersonalInfo';
    import ApplyDocuments from './ApplyDocuments';
    import ApplyFormFooter from './ApplyFormFooter';
    import LoginMixin from '@/components/Utils/LoginMixin';
    import ApplyMixin from './ApplyMixin';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1Button from '@/components/C1Components/C1Button';
    import Vue from 'vue';
    import ScreeningQuestion from './ScreeningQuestion';


    export default {
        name: 'ApplyFormNewUser',

        components: {
            ValidationObserver,
            C1Alert,
            C1Button,
            ApplyPersonalInfo,
            ApplyDocuments,
            ApplyFormFooter,
            ScreeningQuestion,
        },

        mixins: [LoginMixin, ApplyMixin],

        data() {
            return {
                response: {
                    status: '',
                    message: '',
                },
                loader: {
                    apply: false,
                },
            };
        },

        async created() {
            await this.$recaptchaLoaded();
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
                $_me: state => state.me.user,
                $_applyUser: state => state.jobApplication.user,
                $_jobApplication: state => state.jobApplication,
            }),

            ...mapGetters('jobApplication', {
                $_applyEmail: 'applyEmail',
            }),

            applyEmail: {
                get() {
                    return this.$_applyUser.email || this.$_me.email;
                },
                set(newValue) {
                    Vue.set(
                        this.$store.state.jobApplication.user,
                        'email',
                        newValue,
                    );
                },
            },

            showScreeningQuestion() {
                return window?.afConfig?.screening_question_position?.toLowerCase() === 'before job apply';
            },
        },

        methods: {
            async register() {
                const isResumeAttachmentOpt= this.isResumeAttachmentOptional();
                if(isResumeAttachmentOpt){
                    console.log(
                        this.$refs.applyDocuments.$refs.resume.selectedResume,
                    );
                //    return true;
                }
                else {
                    if (
                        this.$refs.applyDocuments.$refs.resume.selectedResume instanceof
                        File
                    ) {
                        console.log(
                            this.$refs.applyDocuments.$refs.resume.selectedResume,
                        );
                    } else {
                        this.response.status = 'danger';
                        this.response.message = 'Resume is mandatory';
                        return false;
                    }
                }
                
                const validation = await this.$refs.formNewUser.validate();
                if (!validation) {
                    return false;
                }

                const token = await this.$recaptcha('register_apply');
                if (!token) {
                    return;
                }

                this.response.status = '';
                this.response.message = '';

                const data = {
                    channel_source: 'jobviewV3-onsite',
                    email: this.$_applyEmail,
                    job_uuid: this.$_job.uuid,
                    token: token,
                };

                data.first_name = this.$_jobApplication.user.first_name;
                data.last_name = this.$_jobApplication.user.last_name;
                data.contact_number = this.$_jobApplication.user.contact_number;

                if (
                    this.$refs.applyDocuments.$refs.resume.selectedResume instanceof
                    File
                ) {
                    data.resume_file = this.$refs.applyDocuments.$refs.resume.selectedResume;
                }

                if (
                    this.$refs.applyDocuments.$refs.coverLetter
                        .selectedCoverLetter instanceof File
                ) {
                    data.cover_letter = this.$refs.applyDocuments.$refs.coverLetter.selectedCoverLetter;
                }

                if (
                    has(
                        this.$refs.applyDocuments.$refs.additionalDocument,
                        'uploadsList',
                    )
                ) {
                    data.additional_docs = this.$refs.applyDocuments.$refs.additionalDocument.uploadsList;
                }

                // Captcha by pass
                if (has(this.$route.query, 'recaptcha_bypass_token')) {
                    data.recaptcha_bypass_token = this.$route.query.recaptcha_bypass_token;
                }

                this.loader.apply = true;
                if (this.$refs.screeningQuestions) {
                    data.screening_questions = this.$refs.screeningQuestions.getResponses();  
                }
                this.$_register(data)
                    .then(response => {
                        this.afterApply(response.apply);
                    })
                    .finally(() => {
                        this.loader.apply = false;
                    });
            },
        },
    };
</script>
